interface UnwrapElementArgs {
  element: Element;
  tagName: string;
}

const unwrapElement = ({ element, tagName }: UnwrapElementArgs): void => {
  const replacement = element.ownerDocument.createElement(tagName);
  replacement.innerHTML = element.innerHTML;
  element.replaceWith(replacement);
};

export const htmlToBlockText = (element: Element): string => {
  element.querySelectorAll('img').forEach((image) => image.remove());

  element
    .querySelectorAll('strong')
    .forEach((strong) => unwrapElement({ element: strong, tagName: 'b' }));

  element.querySelectorAll('em').forEach((em) => unwrapElement({ element: em, tagName: 'i' }));

  element.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.replaceWith(link.ownerDocument.createTextNode(link.textContent ?? ''));
  });

  element.querySelectorAll('a').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return element.innerHTML;
};
